import { put, call, take, fork } from 'redux-saga/effects'
import { questionReportShowUserAnswersService } from '../../api/question'
import { questionReportShowUserAnswersSuccess } from '../../reducers/question/action'
import { QUESTION_REPORT_SHOW_USER_ANSWERS } from '../../reducers/question/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* questionReportShowUserAnswersFlow(payload) {
  try {
    const { reqParams, parentId, callback } = payload

    const response = yield call(questionReportShowUserAnswersService, reqParams)

    yield put(questionReportShowUserAnswersSuccess(response.data, parentId))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* questionReportShowUserAnswersWatcher() {
  while (true) {
    const action = yield take(QUESTION_REPORT_SHOW_USER_ANSWERS)
    const { payload } = action

    yield fork(generalSaga, questionReportShowUserAnswersFlow, payload)
  }
}
